class AudioWorkletProcessor {
	constructor(options?: AudioWorkletNodeOptions) {}
	port: MessagePort;
}

export class SpeedController extends AudioWorkletProcessor {
	constructor(options?: AudioWorkletNodeOptions) {
		super();

		this.originalSamples = options.processorOptions.samples;
		this.originalSampleIndex = 0;
		this.originalSampleCount = this.originalSamples[0].length;

		//this.position = 0;
		//this.velocity = 0.5;

		this.currentIntensity = 0;

		//this.port.onmessage = (event) => {
		//	console.log(event.data);
		//};
	}

	static get parameterDescriptors() {
		return [{ name: 'velocity', defaultValue: 1, minValue: -100, maxValue: 100, automationRate: 'k-rate' }];
	}

	process(inputs, outputs, parameters) {
		let input = inputs[0];
		let output = outputs[0];

		/*
		this.position += this.velocity;
		this.position %= 1;
		if (this.position < 0) {
			this.position += 1;
		}
		*/

		const velocity = parameters.velocity[0];

		//this.originalBufferIndex = Math.floor(this.position * this.originalBufferCount);
		//const v = this.velocity * this.originalBufferCount;

		this.currentIntensity = 0;

		const outputChannelCount = output.length;
		const outputSampleCount = output[0].length;
		for (let i = 0; i < outputSampleCount; ++i) {
			const bufferIndex = Math.floor(this.originalSampleIndex);
			for (let j = 0; j < outputChannelCount; ++j) {
				const value = this.originalSamples[j][bufferIndex];
				output[j][i] = value;
				this.currentIntensity += Math.abs(value);
			}

			//output[0][i] = this.originalBuffer[0][this.originalBufferIndex];
			//output[1][i] = this.originalBuffer[1][this.originalBufferIndex];

			this.originalSampleIndex += velocity;

			if (velocity > 0) {
				//++this.originalBufferIndex;
				if (this.originalSampleIndex >= this.originalSampleCount) {
					this.originalSampleIndex = 0;
				}
			} else {
				//--this.originalBufferIndex;
				if (this.originalSampleIndex < 0) {
					this.originalSampleIndex = this.originalSampleCount - 1;
				}
			}
		}

		this.currentIntensity /= outputChannelCount * outputSampleCount;
		this.port.postMessage({ intensity: this.currentIntensity /*, sampleCount: outputSampleCount*/ });

		/*
		const channelCount = output.length;

		for (let channelIndex = 0; channelIndex < channelCount; ++channelIndex) {
			const outputSamples = output[channelIndex];
			const outputSampleCount = outputSamples.length;

			//const inputSamples = input[channelIndex];
			const originalSamples = this.originalBuffer[channelIndex];

			for (let sampleIndex = 0; sampleIndex < outputSampleCount; ++sampleIndex) {

				if (this.velocity > 0) {
					++this.outputBufferIndices[channelIndex];
					if (this.outputBufferIndices[channelIndex] >= originalSamples.length) {
						this.outputBufferIndices[channelIndex] = 0;
					}
				} else {
					--this.outputBufferIndices[channelIndex];
					if (this.outputBufferIndices[channelIndex] < 0) {
						this.outputBufferIndices[channelIndex] = originalSamples.length - 1;
					}
				}

				outputSamples[sampleIndex] = originalSamples[this.outputBufferIndices[channelIndex]];
			}
		}
		*/

		return true;
	}

	private originalSamples: Float32Array[];
	private originalSampleIndex: number;
	private originalSampleCount: number;

	private currentIntensity: number;

	//private velocity:number;
	//private position:number;
}
